var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4862 1.53962C11.0185 0.100082 8.98188 0.100066 8.51414 1.53962L7.07389 5.97225H2.41315C0.899532 5.97225 0.270178 7.90914 1.49474 8.79884L5.26536 11.5384L3.82511 15.971C3.35737 17.4105 5.00499 18.6076 6.22955 17.7179L10.0002 14.9784L13.7708 17.7179C14.9953 18.6076 16.643 17.4105 16.1752 15.971L14.735 11.5384L18.5056 8.79884C19.7301 7.90915 19.1008 5.97225 17.5872 5.97225H12.9264L11.4862 1.53962Z",
    fill: "#FC8500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.f7ff0fb8fba8214390678edc1ada201f.svg";
export { ForwardRef as ReactComponent };